import { get } from 'lodash';
import { ReactNode, useMemo } from 'react';
import { useRecordContext } from 'react-admin';

import { BoExternalSavingsFundsRequestDetails } from '@Common/types/bo_external/savings_funds_requests';

import { SavingsFundRequestDetails } from '@sh4res/bo-common/components/B2bSavingsFundRequests/SavingsFundRequestDetails';
import { useResourceBasePath } from '@sh4res/bo-common/hooks';

export const B2bSavingsFundRequestShow = ({
  statusAction,
  coPaymentStatusAction,
}: {
  statusAction?: ReactNode;
  coPaymentStatusAction?: ReactNode;
} = {}) => {
  const record = useRecordContext<BoExternalSavingsFundsRequestDetails>();
  const resourceBasePath = useResourceBasePath();
  const savingFundsRequestType = useMemo(() => {
    const type: BoExternalSavingsFundsRequestDetails['type'] | null = get(record, 'type', null);
    return type;
  }, [record]);

  return (
    <SavingsFundRequestDetails
      type={savingFundsRequestType}
      resourceBasePath={resourceBasePath}
      statusAction={statusAction}
      coPaymentStatusAction={coPaymentStatusAction}
    />
  );
};
